import { ValidateRequest } from "./ValidateRequest";
import ValidateResponse, { defaultValue } from "./ValidateResponse";
import { UNANSWERED } from "../../../constants/filterOperator";

const validate = (request: ValidateRequest): Promise<ValidateResponse> => {
    const response = defaultValue();

    if (!request.operator) {
        response.operator.push('Operation is required');
        response.isValid = false;
    }

    if (request.operator === UNANSWERED) {
        return Promise.resolve(response);
    }

    if (request.value === undefined || request.value === null) {
        response.isValid = false;
        response.value.push("A value is required");
    } else if (request.hasPossibleValues && request.value.trim() === '') {
        response.isValid = false;
        response.value.push('A value is required');
    }

    return Promise.resolve(response);
}

export default validate;
